import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

export const HowItWorks = ({ className }: { className?: string }) => {
  const { t: tCommon } = useTranslation('common', { keyPrefix: 'common' });
  const { t } = useTranslation('dbd', { keyPrefix: 'dbd' });

  const statsAnswers = [t('stats.faq.answer0'), t('stats.faq.answer1'), t('stats.faq.answer2')];
  const recentMatchHistoryAnswers = [t('stats.faq.answer3'), t('stats.faq.answer4'), t('stats.faq.answer5')];

  const titlesClass = 'font-display text-display-xs font-bold text-neutral-text-xlight';
  const itemsClass = 'list-disc font-sans text-md text-neutral-text-light';

  return (
    <div
      className={classNames(
        'flex flex-col p-6',
        'bg-surface-dark',
        'rounded-lg',
        'border border-primary-smoke/10',
        className,
      )}
    >
      <h2 className='mb-6 font-display text-display-sm font-bold text-neutral-text-xlight'>
        {tCommon('how-it-works')}
      </h2>
      <h3 className={titlesClass}>{tCommon('statistics')}</h3>
      <ul className='ml-6'>
        {statsAnswers.map((answer, index) => (
          <li key={index} className={itemsClass}>
            <Trans>{answer}</Trans>
          </li>
        ))}
      </ul>

      <h3 className={classNames(titlesClass, 'mt-6 lg:mt-8')}>{tCommon('recent-match-history')}</h3>
      <ul className='ml-6'>
        {recentMatchHistoryAnswers.map((answer, index) => (
          <li key={index} className={itemsClass}>
            <Trans>{answer}</Trans>
          </li>
        ))}
      </ul>
    </div>
  );
};
